import * as Raven from 'raven-js';
import { Injectable, Inject } from '@angular/core';
import { Auth } from '@shared/auth';

import { TRACKING_CONFIG } from './tracking.config';
import { TrackingConfig } from './tracking.interface';

@Injectable()
export class ErrorTracking {
  constructor(
    private auth: Auth,
    @Inject(TRACKING_CONFIG) private config: TrackingConfig,
  ) {
    if (this.config.enableErrorTracking) {
      Raven.config(this.config.sentryDsn, {
        release: this.config.gitRevision,
        tags: {
          releaseDate: this.config.buildDate,
        },
      });
    }
  }

  captureMessage(msg: string, options?: Object): void {
    if (this.config.enableErrorTracking) {
      this.auth
        .map(({ uid }) => {
          this.setUserId(uid);
          Raven.captureMessage(msg, options);
        })
        .toPromise();
    } else {
      console.error(msg, options);
    }
  }

  captureException(error: Error): void {
    if (this.config.enableErrorTracking) {
      this.auth
        .map(({ uid }) => {
          this.setUserId(uid);
          Raven.captureException(error);
        })
        .toPromise();
    } else {
      console.error(error);
    }
  }

  private setUserId(id: number) {
    if (id) {
      Raven.setUserContext({ id: String(id) });
    } else {
      Raven.setUserContext();
    }
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/tracking/error-tracking.service.ts